import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './pages.css';
import {
  clearRejectedEmail,
  clearRestrictedSession,
  readRejectedEmail,
} from '../functions/restrictedAccess';

/**
 * Shown when the API rejects an account that is not on this environment's
 * allowlist. Restricted stacks (QA) share the production Cognito user pool, so a
 * user can hold a perfectly valid token and still have no access here.
 */
export default function NotAuthorized() {
  const navigate = useNavigate();
  const [email] = useState(readRejectedEmail);

  // Landing here means the session is not usable — make sure nothing survives it,
  // including when the page is opened directly.
  useEffect(() => {
    clearRestrictedSession(email);
  }, [email]);

  const backToLogin = () => {
    clearRejectedEmail();
    navigate('/login');
  };

  return (
    <div className="na-page">
      <div className="na-card">
        <span className="na-icon" aria-hidden="true">🔒</span>
        <h1 className="na-title">Not authorized</h1>
        <p className="na-body">
          {email ? (
            <>
              <strong className="na-email">{email}</strong> is not permitted to use this
              environment.
            </>
          ) : (
            <>This account is not permitted to use this environment.</>
          )}
        </p>
        <p className="na-hint">
          Access here is limited to approved accounts. Your sign-in credentials are fine —
          they just are not authorized on this deployment. If you reached this by mistake,
          use the production site instead.
        </p>
        <div className="na-actions">
          <button type="button" className="na-btn-primary" onClick={backToLogin}>
            Back to login
          </button>
          <Link to="/" className="na-btn-secondary">Go to home</Link>
        </div>
      </div>
    </div>
  );
}
